import React from 'react';
import Breadcrumb from '../Breadcrumb';
import ImageWrapper from '../ImageWrapper';
import { ComposedHeroProps } from './props';
import './styles.scss';

const ComposedHero = ({ breadcrumbs, title, subtitle, heroImage }: ComposedHeroProps) => {
  return (
    <div className='composed-hero'>
      {breadcrumbs && (
        <div className='composed-hero-breadcrumbs'>
          <Breadcrumb items={breadcrumbs} />
        </div>
      )}
      <div className='composed-hero-header'>
        <p>{title}</p>
        {subtitle && <h1>{subtitle}</h1>}
      </div>

      <div className='composed-hero-image'>
        <ImageWrapper lazyLoading={true} {...heroImage} />
      </div>
    </div>
  );
};

export default ComposedHero;
